import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { requestHelpers } from 'helpers';
import { userServices } from 'services';

const getAuthorization = () => {
  return userServices.isLoggedIn()
    ? `Bearer ${userServices.getAccessToken()}`
    : '';
};

// Do something before request is sent
const requestInterceptor = (request: AxiosRequestConfig) => {
  request.headers.Authorization = getAuthorization();
  return request;
};

const requestInterceptorForFile = (request: AxiosRequestConfig) => {
  request.headers.Authorization = getAuthorization();
  request.headers['Content-Type'] = 'multipart/form-data';
  return request;
};

// Any status code that lie within the range of 2xx cause this function to trigger
const responseSuccessInterceptor = (response: AxiosResponse) => {
  // Do something with response data
  return response;
};

// Any status codes that falls outside the range of 2xx cause this function to trigger
const responseErrorInterceptor = (error: AxiosError) => {
  // Do something with response error
  requestHelpers.handleResponseError(error);
  return Promise.reject(error);
};

export function wrapClient(client: AxiosInstance): AxiosInstance {
  client.interceptors.request.use(requestInterceptor);
  client.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );

  return client;
}

export function wrapClientForUploadFile(client: AxiosInstance): AxiosInstance {
  client.interceptors.request.use(requestInterceptorForFile);
  client.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );

  return client;
}
